import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";

export default function toLogin(push, backUrl) {
  const { fullPath, name } = router.currentRoute;

  if (["Login", "Register", "RetrievePassword"].includes(name)) {
    return;
  }

  store.commit("LOGOUT");
  cookie.set("login_back_url", backUrl || fullPath);

  if (name !== "Login") {
    push
      ? router.push({ path: "/login" })
      : router.replace({ path: "/login" });
  }
}